import { render, staticRenderFns } from "./Government.vue?vue&type=template&id=42f342a4&scoped=true"
import script from "./Government.vue?vue&type=script&lang=js"
export * from "./Government.vue?vue&type=script&lang=js"
import style0 from "./Government.vue?vue&type=style&index=0&id=42f342a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f342a4",
  null
  
)

export default component.exports